module.exports = __webpack_public_path__ + "assets/img/player_details_red_yellow.png?e74d1a0bcc1d88720798cbd24cde99e8";